import { render, staticRenderFns } from "./SelezioneArea.vue?vue&type=template&id=1d5960ab&"
import script from "./SelezioneArea.vue?vue&type=script&lang=js&"
export * from "./SelezioneArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports